import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import {
  getUserDeviceInformation,
  getSurveyDevicesList,
} from "../../Utils/userFunctions";
import { Table, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
function UserDevices() {
  const [show, setShow] = useState(false);
  const [devicesList, setDevicesList] = useState("");
  const [tmpDeviceSurveyList, setTmpDeviceSurveyList] = useState("");
  const [tmpDeviceName, setTmpDeviceName] = useState("");
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = (deviceID, deviceName) => {
    setShow(true);
    setTmpDeviceName(deviceName);
    async function fetchAPI11() {
      const response = await getSurveyDevicesList(deviceID);
      if (response.status === "success") {
        setTmpDeviceSurveyList(response.optionItems);
      } else {
        setTmpDeviceSurveyList("");
      }
    }
    fetchAPI11();
  };
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getUserDeviceInformation();
      if (response.status == "success") {
        if (response.data.manufacturer_devices_list) {
          let optionItems = response.data.manufacturer_devices_list.map(
            (item) => (
              <div
                className="col-md-3 mb-3 d-flex align-items-stretch"
                key={item.device_id}
              >
                <div
                  className="card products-card active dev_device_survey"
                  onClick={() => {
                    handleShow(item.device_id, item.device_name);
                  }}
                >
                  <div className="products-card-media">
                    <center>
                      <img src={item.device_image} alt="N/A" />
                    </center>
                  </div>
                  <div className="products-card-content">
                    <h4>{item.device_name}</h4>
                  </div>
                </div>
              </div>
            )
          );
          setDevicesList(optionItems);
        } else {
          setDevicesList("");
        }
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  return (
    <div>
      <UserHeader />
      <ToastContainer></ToastContainer>
      <div className="container">
        <div className="row mt-4">
          <div className="col-sm-12 col-lg-12">
            <div className="row">{devicesList}</div>
          </div>
        </div>
        <div className="row">
          <Modal show={show} onHide={handleClose} animation={false}>
            <Modal.Header className="modal_custom_header text-center">
              <h5 className="text-white p-0 m-0">{tmpDeviceName}</h5>
            </Modal.Header>
            <Modal.Body>
              <div className="show_list">
                <Table bordered size="sm" className="card-table">
                  <tbody>
                    {tmpDeviceSurveyList.length > 0 ? (
                      tmpDeviceSurveyList
                    ) : (
                      <>
                        <tr>
                          <td colSpan={1}>
                            {" "}
                            <div className="text-center">No records found</div>
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </div>
  );
}
export default UserDevices;
